module.exports = __webpack_public_path__ + "static/img/刮板运输机断链监测.d8bd6d15.png";